import { ca } from "date-fns/locale";

const funcaoAgregacaoPadrao = "sum";

function criarAgrupadores(dados, camposDimensao) {
    const mapGrupos = new Map();

    dados.forEach(registro => {
        const hashGrupo = camposDimensao.map(c => registro[c.campo]).join("#");
        if (!mapGrupos.has(hashGrupo)) {
            const newGroup = {
                __dados__: [],
                hash: hashGrupo
            };
            camposDimensao.forEach(campo => {
                newGroup[campo.dataField] = registro[campo.campo];
            });
            mapGrupos.set(hashGrupo, newGroup);
        }
        mapGrupos.get(hashGrupo).__dados__.push(registro);
    });

    return Array.from(mapGrupos.values());
}

function executarExpressoesAgrupadores(agrupadores, camposMedida) {
    camposMedida.forEach(campoMedida => {
        agrupadores.forEach((agrupador, index) => {
            if (campoMedida.calculo)
                executarFuncaoAgregacaoComCalculoDinamico(agrupadores, index, campoMedida, camposMedida);
            else
                agrupador[campoMedida.dataField] = executarFuncaoAgregacaoSimples(agrupador.__dados__, campoMedida);
        });
    });
}

function fazSumariosExecucaoDinamica(valorExpressao, dadosAgrupamento, agrupador) {
    let regEx = valorExpressao.match(/((Sum|Avg|Max|Min|Count)\s*?\(.*?\))/gimu); //["Sum([Quantidade])", "Avg([Valor])""]
    if (regEx != null)
        for (let expr = 0; expr < regEx.length; expr++) {
            let funcS = /(Sum|Avg|Max|Min|Count)\s*?\((.*?)\)/gimu.exec(regEx[expr]); //["Sum([Quantidade])", "Sum", "[Quantidade]"]
            let campoFunc = funcS[2].replace("[", "").replace("]", "");
            let _valor = 0;

            if (agrupador[`_${funcS[1].toLowerCase()}_${campoFunc}_`]) {
                _valor = agrupador[`_${funcS[1].toLowerCase()}_${campoFunc}_`];
            }
            else {
                switch (funcS[1].toLowerCase()) {
                    case "sum":
                        _valor = dadosAgrupamento.reduce(function (a, b) {
                            return b[campoFunc] == null ? a : a + b[campoFunc];
                        }, 0);
                        break;
                    case "avg":
                        _valor = dadosAgrupamento.reduce(function (a, b) {
                            return b[campoFunc] == null ? a : a + b[campoFunc];
                        }, 0) / dadosAgrupamento.length;
                        break;
                    case "min":
                        _valor = dadosAgrupamento.reduce(function (a, b) {
                            return a == null ? b[campoFunc] : (b[campoFunc] == null ? a : (a > b[campoFunc] ? b[campoFunc] : a));
                        }, null);
                        break;
                    case "max":
                        _valor = dadosAgrupamento.reduce(function (a, b) {
                            return a == null ? b[campoFunc] : (b[campoFunc] == null ? a : (a < b[campoFunc] ? b[campoFunc] : a));
                        }, null);
                        break;
                    case "count":
                        _valor = dadosAgrupamento.length;
                        break;
                }
                agrupador[`_${funcS[1].toLowerCase()}_${campoFunc}_`] = _valor;
            }

            valorExpressao = valorExpressao.replace(funcS[0], _valor);
        }

    return valorExpressao;
}

function executarFuncaoAgregacaoComCalculoDinamico(agrupadores, indexAgrupador, campoMedida, camposMedida) {
    
    let agrupador = agrupadores[indexAgrupador];
    let dadosAgrupamento = agrupador.__dados__;
    let valorExpressao = campoMedida.funcao;

    let _totais = [];
    
    let regEx = valorExpressao.match(/((Acumular|RankAsc|RankDesc)\s*?\(.*?\)\))/gimu);
    if (regEx != null)
        for (let expr = 0; expr < regEx.length; expr++) {
            
            let func = /((Acumular|RankAsc|RankDesc)\s*?\((.*?\))\))/gimu.exec(regEx[expr]);
            let funcS = /(Sum|Avg|Max|Min|Count)\s*?\((.*?)\)/gimu.exec(func[3]);
            let campoFunc = funcS[2].replace("[", "").replace("]", "");
            
            switch (func[2].toLowerCase()) {
                case "acumular":
                    let _acumulado = 0;
                    if (camposMedida.find(function (e) { return e.funcao == funcS[1]; }) !== undefined) {
                        let _coluna = camposMedida.filter(function (e) { return e.funcao == funcS[1]; })[0].dataField;
                        _acumulado = agrupador[_coluna];
                        if (indexAgrupador > 0)
                            _acumulado += agrupadores[indexAgrupador - 1][campoMedida.dataField];
                    }
                    else { //reaproveita
                        _acumulado = parseFloat(fazSumariosExecucaoDinamica(func[3], dadosAgrupamento, agrupador));
                        if (indexAgrupador > 0)
                            _acumulado += agrupadores[indexAgrupador - 1][campoMedida.dataField];
                    }
                    valorExpressao = valorExpressao.replace(regEx[expr], _acumulado);
                    break;
                case "rankasc":
                case "rankdesc":
                    let _valor = 0;
                    if (agrupador[`_${funcS[1].toLowerCase()}_${campoFunc}_`])
                        _valor = agrupador[`_${funcS[1].toLowerCase()}_${campoFunc}_`];
                    else
                        _valor = parseFloat(fazSumariosExecucaoDinamica(func[3], dadosAgrupamento, agrupador));
                    switch (func[2].toLowerCase()) {
                        case "rankasc":
                            valorExpressao = valorExpressao.replace(func[0], Array.from(new Set(agrupadores.map(function(e) { return parseFloat(e[`_${funcS[1].toLowerCase()}_${campoFunc}_`]); }).sort(sortNumber))).indexOf(_valor) + 1);
                            break;
                        case "rankdesc":
                            valorExpressao = valorExpressao.replace(func[0], Array.from(new Set(agrupadores.map(function(e) { return parseFloat(e[`_${funcS[1].toLowerCase()}_${campoFunc}_`]); }).sort(sortNumber).reverse())).indexOf(_valor) + 1);
                            break;
                    }
                    break;
            }
        }

    regEx = valorExpressao.match(/Total\s*?\(\s*?((Sum|Avg|Max|Min|Count)\s*?\(.*?\))\)/gimu);
    if (regEx != null)
        for (let expr = 0; expr < regEx.length; expr++) {
            let func = /Total\s*?\(\s*?((Sum|Avg|Max|Min|Count)\s*?\(.*?\))\)/gimu.exec(regEx[expr]);
            let _total = 0;
            if (_totais[func[1]])
                _total = _totais[func[1]];
            else {
                if (camposMedida.find(function (e) { return e.funcao == func[1]; }) == undefined) {
                    for (var posRegAux = 0; posRegAux < agrupadores.length; posRegAux++) {
                        _total += parseFloat(fazSumariosExecucaoDinamica(func[1], agrupadores[posRegAux].__dados__, agrupadores[posRegAux]));
                    }
                }
                else { //aproveita que já foi calculado pra alguma coluna
                    var _coluna = camposMedida.filter(function (e) { return e.funcao == func[1]; })[0].dataField;
                    for (var posRegAux = 0; posRegAux < agrupadores.length; posRegAux++)
                        _total += agrupadores[posRegAux][_coluna];
                }
                _totais[func[1]] = _total;
            }
            valorExpressao = valorExpressao.replace(regEx[expr], _total);
            break;
        }

    regEx = valorExpressao.match(/(Lookup\(.+?,\s?-?\d+\))/gimu);
    if (regEx != null)
        for (let expr = 0; expr < regEx.length; expr++) {
            let func = /Lookup\((.+?),\s?(-?\d+)\)/gimu.exec(regEx[expr]);
            if (indexAgrupador > 0) {
                var _valorAnterior = 0;
                if (camposMedida.find(function (e) { return e.funcao == func[1]; }) == undefined) {
                    _valorAnterior = parseFloat(fazSumariosExecucaoDinamica(func[1], agrupadores[indexAgrupador-1].__dados__, agrupadores[indexAgrupador-1]));
                }
                else { //aproveita que já foi calculado pra alguma coluna
                    _valorAnterior = agrupadores[indexAgrupador - 1][`_${campoMedida.funcaoAgregacao.toLowerCase()}_${campoMedida.campo}_`];
                }
                valorExpressao = valorExpressao.replace(func[0], _valorAnterior);
            }
            else {
                if (campoMedida.calculo === "diferenca_do_anterior" || campoMedida.calculo === "diferenca_do_anterior_percentual")
                    valorExpressao = "";
                else
                    valorExpressao = valorExpressao.replace(func[0], 0);
            }
        }

    regEx = valorExpressao.match(/((ToDouble)\(.*?\))/gimu);
    if (regEx != null)
        for (let expr = 0; expr < regEx.length; expr++) {
            valorExpressao = valorExpressao.replace("ToDouble", "parseFloat");
        }

    valorExpressao = fazSumariosExecucaoDinamica(valorExpressao, dadosAgrupamento, agrupador);
    try {
        if (campoMedida.dataType == 'number' || campoMedida.funcaoAgregacao == 'count')
            agrupador[campoMedida.dataField] = eval(valorExpressao);
        else
            agrupador[campoMedida.dataField] = eval(JSON.stringify(valorExpressao))
    }
    catch(ex) {
        console.error(ex.message);
    }
    
}

function executarFuncaoAgregacaoSimples(dadosAgrupamento, campoMedida) {
    switch (campoMedida.funcaoAgregacao.toLowerCase()) {
        default: //sum como funcao padrao
        case "sum":
            return dadosAgrupamento.reduce((acumulador, valorAtual) => valorAtual[campoMedida.campo] == null 
                ? acumulador 
                : acumulador + valorAtual[campoMedida.campo], 0);
        case "avg":
            let total = dadosAgrupamento.reduce((acumulador, valorAtual) => valorAtual[campoMedida.campo] == null
                ? acumulador
                : acumulador + valorAtual[campoMedida.campo], 0);
            
            return total / dadosAgrupamento.length;
        case "min":
            return dadosAgrupamento.reduce((acumulador, valorAtual) => {
                return acumulador == null ? valorAtual[campoMedida.campo] : (valorAtual[campoMedida.campo] == null ? acumulador : (acumulador > valorAtual[campoMedida.campo] ? valorAtual[campoMedida.campo] : acumulador));
            }, null);
        case "max":
            return dadosAgrupamento.reduce(function (acumuador, valorAtual) {
                return acumuador == null ? valorAtual[campoMedida.campo] : (valorAtual[campoMedida.campo] == null ? acumuador : (acumuador < valorAtual[campoMedida.campo] ? valorAtual[campoMedida.campo] : acumuador));
            }, null);
        case "count":
            return dadosAgrupamento.length;
    }
}

export default {
    Expression: {
        agregarDados: function (dados, colunas) {
            const camposDimensao = colunas.filter(e => e.tipo === "dimensao");
            const camposMedida = colunas.filter(e => e.tipo === "medida").map(campo => ({
                ...campo,
                funcaoAgregacao: campo.funcaoAgregacao || funcaoAgregacaoPadrao,
                funcao: campo.funcao == undefined || campo.funcao == ""
                    ? `${campo.funcaoAgregacao}([${campo.campo}])`
                    : campo.funcao
            }));
            
            const agrupadores = criarAgrupadores(dados, camposDimensao);

            executarExpressoesAgrupadores(agrupadores, camposMedida);

            return agrupadores;
        },
        getFuncaoDoCalculo: function (calculo, defFuncao, campo) {
            switch (calculo) {
                case "percentual_do_total":                        
                    return `${defFuncao}([${campo}]) / Total(${defFuncao}([${campo}]))`;
                case "acumulador":
                    return `Acumular(${defFuncao}([${campo}]))`;
                case "diferenca_do_anterior":
                    return `${defFuncao}([${campo}]) - Lookup(${defFuncao}([${campo}]), -1)`;
                case "diferenca_do_anterior_percentual":
                    return `ToDouble(${defFuncao}([${campo}]) - Lookup(${defFuncao}([${campo}]), -1)) / Lookup(${defFuncao}([${campo}]), -1)`;
                case "rank_asc":
                    return `RankAsc(${defFuncao}([${campo}]))`;
                case "rank_desc":
                    return `RankDesc(${defFuncao}([${campo}]))`;
                case "personalizado":
                    return `${defFuncao}([${campo}])`;
            }
        },

        getDataTypeByTipoCampo: function(tipo) {
            switch (tipo) {
                case "BLOB":
                    return "object";
                case "DATE":
                    return "date";
                case "DATETIME":
                case "TIME":
                    return "datetime";
                case "DOUBLE":
                case "INTEGER":
                    return "number";
                case "BOOLEAN":
                    return "boolean";
                case "VARYING":
                default:
                    return "string";
            }
        },

        getDataTypeToArgumentType: function(tipo) {
            switch (tipo) {
                case "BLOB":
                    return undefined;
                case "DATE":
                case "TIME":
                case "DATETIME":
                    return "datetime";
                case "DOUBLE":
                case "INTEGER":
                    return "numeric";
                case "VARYING":
                default:
                    return "string";
            }
        },

        getPivotGridDataTypeByTipoCampo: function(tipo) {
            switch (tipo) {
                case "BLOB":
                    return undefined;
                case "DATE":
                case "TIME":
                case "DATETIME":
                    return "date";
                case "DOUBLE":
                case "INTEGER":
                    return "number";
                case "VARYING":
                default:
                    return "string";
            }
        },        

        getAggregationIntervalByFormat: function(formatacao) {
            switch ((formatacao || {}).type) {
                case 'longDateLongTime':
                case 'shortDateShortTime':
                    return 'minutes'
                case 'day':
                case 'dayOfWeek':
                case 'longDate':
                case 'shortDate':
                case 'monthAndDay':
                    return 'days'
                case 'month':
                case 'monthAndYear':
                    return 'months'
                case 'year':
                    return 'years'
                case 'quarter':
                case 'quarterAndYear':
                    return 'quarters'
                case 'millisecond':
                    return 'milliseconds'
                case 'second':
                    return 'seconds'
                case 'minute':
                    return 'minutes'
                case 'hour':
                case 'shortTime':
                case 'longTime':
                    return 'hours'
                default:
                    return ''
            }
        },

        getFuncaoCC: function (expressao) {
            if (expressao == '')
                expressao = '""';
            else
                expressao = expressao.replace(/\[(.+?)\]/g, "_dados[\"$1\"]"); //ex: transforma [qtd_item] em _dados["qtd_item"]
            if (!expressao.startsWith("return"))
                expressao = "return " + expressao;
            return new Function("_dados", expressao);
        },

    },
}